export class CustomCarouselController {
  totalDistanceScrolled = 0;
  totalVisitedDistance = 0;
  isShowLeftButton = false;
  isShowRightButton = true;
  childWidth: number;
  scrollItemsContainer: any;
  constructor(private $element: ng.IAugmentedJQuery, private $timeout: ng.ITimeoutService) {}
  $postLink(): void {
    this.$timeout(() => {
      this.scrollItemsContainer = this.$element.find('div.items')[0];
      const scrollItem = this.$element.find('.scroll-item')[0];
      this.childWidth = (scrollItem && scrollItem.getBoundingClientRect().width) || 0;
      if (this.scrollItemsContainer.clientWidth >= this.scrollItemsContainer.scrollWidth) {
        this.isShowLeftButton = false;
        this.isShowRightButton = false;
      }
    }, 100);
  }

  scrollLeft(): void {
    this.isShowLeftButton = true;
    if (this.totalDistanceScrolled < this.scrollItemsContainer.scrollWidth) {
      this.totalVisitedDistance =
        this.scrollItemsContainer.scrollWidth -
        (this.totalDistanceScrolled + this._containerWidth(this.scrollItemsContainer));
      if (this.totalVisitedDistance < 0) {
        return;
      }
      if (this.totalVisitedDistance < this._containerWidth(this.scrollItemsContainer)) {
        this.totalDistanceScrolled += this.totalVisitedDistance;
        this._scrollContent(this.scrollItemsContainer, this.totalDistanceScrolled);
        this.isShowRightButton = false;
      } else {
        this.totalDistanceScrolled += this._containerWidth(this.scrollItemsContainer);
        this._scrollContent(this.scrollItemsContainer, this.totalDistanceScrolled);
      }
    }
  }
  scrollRight(): void {
    this.isShowRightButton = true;
    const portionOfContainerWidthMoved = this.totalDistanceScrolled % this._containerWidth(this.scrollItemsContainer);
    if (portionOfContainerWidthMoved === 0) {
      const noOfStepsMoved = this.totalDistanceScrolled / this._containerWidth(this.scrollItemsContainer) - 1;
      if (noOfStepsMoved === 0) {
        this.isShowLeftButton = false;
      }
      const distanceToScroll = noOfStepsMoved * this._containerWidth(this.scrollItemsContainer);
      this.totalDistanceScrolled -= this._containerWidth(this.scrollItemsContainer);
      this._scrollContent(this.scrollItemsContainer, distanceToScroll);
    } else {
      this.totalDistanceScrolled -= portionOfContainerWidthMoved;
      this._scrollContent(this.scrollItemsContainer, this.totalDistanceScrolled);
      if (this.totalDistanceScrolled === 0) {
        this.isShowLeftButton = false;
      }
    }
  }

  _containerWidth(container: any): number {
    const containerWidth = container.getBoundingClientRect().width;
    const unusedContainerWidth = (this.childWidth && containerWidth % this.childWidth) || 0;
    return containerWidth - unusedContainerWidth;
  }
  _scrollContent(element: any, distanceToScroll: number) {
    element.style.transform = `translateX(-${distanceToScroll}px)`;
  }
}

export class CustomCarouselComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-todos/src/components/custom_carousel/custom_carousel.html';
  public controller: any = CustomCarouselController;
  public controllerAs: string = '$ctrl';
  public transclude: boolean = true;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/components/custom_carousel/custom_carousel.ts